import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#default-time-for-start-date-and-end-date" }),
  /*#__PURE__*/_createTextVNode(" Default time for start date and end date ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " When picking a date range, you can assign the time part for start date and end date. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("p", null, "Component value：" + _toDisplayString(_ctx.value), 1),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
          type: "daterange",
          "start-placeholder": "Start date",
          "end-placeholder": "End date",
          "default-time": _ctx.defaultTime
        }, null, 8, ["modelValue", "default-time"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}